import { useEffect, useRef } from 'react';

const useClickOutside = (callback, condition = true) => {
    const node = useRef();


    const handleClick = (e) => {
        if (!node.current.contains(e.target)) {
            callback();
        }
    };

    useEffect(() => {
        if (condition) {
            document.addEventListener('mousedown', handleClick);
        } else {
            document.removeEventListener('mousedown', handleClick);
        }

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [condition]);
    return node;
};

export default useClickOutside;